import { render, staticRenderFns } from "./OrderDataBlock.vue?vue&type=template&id=dba15458&"
import script from "./OrderDataBlock.vue?vue&type=script&lang=js&"
export * from "./OrderDataBlock.vue?vue&type=script&lang=js&"
import style0 from "./OrderDataBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports